import styled from "styled-components";

export const ClockContainer = styled.div`
    z-index: 3;
    position: absolute;
    top: 10%;
    left: 10%;
`;